<template>
  <HeaderTrade/> 
  <!-- Container Start { -->
  <div id="container">
    <!-- Contents Start { -->
    <div id="contents">

      <!-- content start -->
      <div class="contents-area">

        <!-- <div class="top-nav-tab">
          <ul>
            <li><router-link :to="{ name: 'Community'}" class="active">자유게시판</router-link></li>
          </ul>
        </div> -->

        <!-- 커뮤니티 선택 영역 -->

        <div class="bbs-filter-finder">
          <ul class="finder-list">
            <li><a href="javascript:;" class="item" ref="allCategory" @click="onResetCategoryCode">전체글</a></li>
            <li
              v-for="(item, index) in categorylist"
              :key="index"
               @click="onFilterSelect"
            >
              <a href="javascript:;" class="item" :id="`${item.CODE}`">{{ item.NAME }}</a>
            </li>
          </ul>
        </div>

        <!-- 커뮤니티 리스트 start -->
        <div class="bbs-list-inner">
          <div class="list-title-select">
            <select class="form-select" aria-label="select" @change="onSelectChange">
              <option value="5" selected>5개 보기</option>
              <option value="10">10개 보기</option>
              <option value="20">20개 보기</option>
              <option value="30">30개 보기</option>
              <option value="40">40개 보기</option>
              <option value="50">50개 보기</option>
            </select>
          </div>
      
          <!-- 공지사항리스트 start -->
          <div class="bbs-list-li notice">
            <ul>
              <li
                v-for="(item, index) in noticeList"
                :key = index            
              >
                <router-link :to="{ name:'NoticeView',  params:{ id:item.IDX }}"  class="link">
                  <p class="txt text-truncate">
                    <span class="badge">공지</span>
                    <strong>{{item.SUBJECT}}</strong>
                  </p>
                  <span class="writer text-truncate">FLEXMONEY</span>
                  <span class="date">{{item.CREATIONDATE.split(' ')[0].replaceAll('-','.')}}</span>
                </router-link>       
              </li>
            </ul>
          </div>
      
          <!-- 게시판 리스트 start -->
          <div class="bbs-list-li">
            <ul>
              <li
                v-for="(item, index) in boardList"
                :key = index            
              >
                <router-link :to="{ name:'CommunityView',  params:{ id:item.IDX }}"  class="link">
                  <p>
                    <span class="subject text-truncate">{{item.SUBJECT}}</span>
                    <span class="reply">[{{ item.COMMENT_COUNT }}]</span>
                  </p>
                  <div class="nick">
                    <span>{{item.CATEGORY_NAME }}</span>
                    <span class="writer text-truncate">
                      <UserNickGrade
                        :itemGrade="item.GRADE"
                        :itemGradeRank="item.GRADE_RANK"
                        :itemNickName="item.MB_NICK"
                      />
                    </span>
                    <span class="date">{{item.CREATIONDATE.split(' ')[0].replaceAll('-','.')}}</span>
                    <span>{{ item.COUNT }}</span>
                    <span>{{item.LIKE_COUNT}}/{{item.DISLIKE_COUNT}}</span>
                  </div>
                </router-link>       
              </li>
            </ul>
          </div>
        
          <div v-if="!boardList.length" class="bbs-list-none">게시글이 없습니다.</div>
        </div>
        <!-- //게시판 리스트 End -->

        <!-- 검색 영역 / 글쓰기 버튼 start -->
        <div class="bbs-list-control">
          <button type="button" class="control-btn-write btn btn-danger" v-if="isLogin" @click="writeClickHandle">글쓰기</button>
          <div class="control-select">
            <select class="form-select" v-model="srchType">
              <option value="search_like" selected="selected">제목+내용</option>
              <option value="subject_like">제목</option>
              <option value="contents_like">내용</option>
              <option value="mb_nick">닉네임</option>
            </select>
          </div>
          <div class="control-search">
            <input type="text" class="form-control form-control-sm" aria-label="search" placeholder="검색어를 입력하세요." id="inputSearch" v-model="srchKeyword" @keyup.enter="srchCommunity">
            <button class="btn-search" type="button"><img src="@/assets/images/common/ico_header_search.png" alt="search" @click="srchCommunity"></button>
          </div>
        </div>
        <!-- //검색 영역 / 글쓰기 버튼 end -->

        <!-- 페이징 start-->
        <div class="paging-area" v-if="boardList.length">
           <v-pagination                  
                v-model="currentPage"
                :pages='numberOfPages'
                :rangeSize="1"
                @update:modelValue="updateHandler(currentPage, categoryType, categoryCode)"
            />
        </div>
        <!-- //페이징 end -->        

      </div>
      <!-- //content end -->  

    </div>
    <!-- } Contents End -->

  </div>
  <!-- } Container End -->
  <Footer/>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter }from 'vue-router';
import { useRoute }from 'vue-router';
import { ref, getCurrentInstance, onMounted, computed, onUnmounted } from 'vue';
import { useApicall } from '@/composables/commonFn';
import HeaderTrade from '@/components/HeaderTrade.vue';
import Footer from '@/components/Footer.vue';
import UserNickGrade from '@/components/UserNickGrade.vue';
import VPagination from "@hennge/vue3-pagination";

export default {
  components:{  
    HeaderTrade, 
    Footer,
    VPagination,
    UserNickGrade,
  },

  setup() {
    const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
    const store = useStore();
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_1'); 
    store.commit('common/CHANGE_CURRENT_PAGE', 'Community');    
    const boardList = ref([]);
    const limit = ref(5);
    const currentPage = ref(1);     
    const numberOfData = ref(0);
    const numberOfPages = computed(()=>{
    return Math.ceil(numberOfData.value/limit.value)
    });
    const {apiCall_g, apiCall_gt} = useApicall();
    const categorylist = ref([]);
    const categoryType = ref('community');
    const categoryCode = ref([]);
    const noticeList = ref([]);
    const router = useRouter();
    const route = useRoute();
    const isLogin = computed(() => store.state.user.isLogin);
    const currentPage_store = computed(() => store.state.common.cummunityCurrentPage);
    const page_store = computed(() => store.state.common.currentPage);
    const category_store = computed(() => store.state.common.cummunityCurrentCategory);

    const srchType = ref('search_like');
    const srchKeyword = ref('');

    const allCategory = ref(null);

    onMounted(async ()=> {   
      emitter.emit('EVENT_CHECK_LOGIN');       
      categorylist.value = await getCategorylist();
      noticeList.value = await getNoticelist();
      setCategoryCode();
      //  trace("noticeList", noticeList.value);
    })

    const updateHandler = (e, _cType, _cCode) => {
      getDataList(e,  _cType, _cCode);
    }

    const getDataList  = async(page = currentPage.value, categoryType, categoryCode) =>{    
      currentPage.value = page; 
      store.commit('common/CHANGE_CUMMUNITY_CURRENT_PAGE', page);

      var offset = (currentPage.value -1)*limit.value;
      var getUrl = `board/list?limit=${limit.value}&offset=${offset}&categoryType=${categoryType}`;

      if( categoryCode != 0 && categoryCode != null) {
        var addCategory = `&categoryArr=${categoryCode.toString()}`;
        getUrl += addCategory;
      }

      if(srchKeyword.value) {
        var addurl = `&${srchType.value}=${srchKeyword.value}`;
        getUrl += addurl;
      }

      var boardDataList = await apiCall_gt(getUrl)

      try {
        if(boardDataList.dataList == null) boardDataList.dataList = [];
        boardList.value = boardDataList.dataList;
        numberOfData.value = boardDataList.dataCount;
      } catch( error ) {
        boardList.value = [];
        numberOfData.value  = 0;
      }
    }

    const setCategoryCode = () => {
      // console.log('setCategoryCode =======>', categoryCode.value, category_store.value)
      categoryCode.value = category_store.value;

      if( categoryCode.value != 0 && categoryCode.value != null) {
        categoryCode.value.forEach((category) => {
          if(document.getElementById(category)) {
            document.getElementById(category).classList.add('active');
          } else {
            allCategory.value.classList.add('active');
            categoryCode.value = [];
            store.commit('common/CHANGE_CUMMUNITY_CURRENT_CATEGORY', []);
          }
        });
        updateHandler(currentPage_store.value, categoryType.value, categoryCode.value);
      } else {
        allCategory.value.classList.add('active');
        categoryCode.value = [];
        updateHandler(currentPage_store.value, categoryType.value, []);
        store.commit('common/CHANGE_CUMMUNITY_CURRENT_CATEGORY', []);
      }
    }

    const onResetCategoryCode = () => {
      var selectedLists = document.querySelectorAll('.finder-list .item.active');
      selectedLists.forEach((list) => {
        list.classList.remove('active');
      });
      allCategory.value.classList.add('active');
      categoryCode.value = [];
      updateHandler(currentPage_store.value, categoryType.value, []);
      store.commit('common/CHANGE_CUMMUNITY_CURRENT_CATEGORY', []);
    }

    const onFilterSelect = (e) => {
      var btn = e.target;
      var selectedLists = document.querySelectorAll('.finder-list .item.active');

      // 단일선택 변경으로 인한 초기화 추가
      categoryCode.value = [];   

      if(allCategory.value.classList.contains('active')) {
        allCategory.value.classList.remove('active');
      }

      if(selectedLists.length > 4) {
        if(btn.classList.contains('active')) {
          onDeleteFilterList(e);
          btn.classList.remove('active');
          return false;
        } else {
          emitter.emit('EVENT_ALERT',{title:"알림", body:"카테고리는 5개까지 선택 가능합니다."});
          return false;  
        }
      }

      if(btn.classList.contains('active')) {
        onDeleteFilterList(e);
        btn.classList.remove('active');
      } else {
        // 단일선택 변경으로 인한 초기화 추가
        selectedLists.forEach((finder) => {
          finder.classList.remove('active');
        });
        
        btn.classList.add('active');
        categoryCode.value.push(btn.id);
        updateHandler( 1, categoryType.value, categoryCode.value);
        store.commit('common/CHANGE_CUMMUNITY_CURRENT_CATEGORY', categoryCode.value);
      }
      // console.log('category_store ======>', category_store.value, categoryCode.value, JSON.parse(sessionStorage.getItem('cummunityCurrentCategory')))
    }

    const onDeleteFilterList = (e) => {
      var item = e.target;
      var selectedLists = document.querySelectorAll('.finder-list .item.active');
      let categoryArr = categoryCode.value;

      if(selectedLists.length-1 == 0) {
        allCategory.value.classList.add('active');
        categoryCode.value = [];
      } else {
        item.classList.remove('active');
        categoryCode.value = categoryArr.filter((element) => element !== item.id);
      }

      updateHandler( 1, categoryType.value, categoryCode.value );
      store.commit('common/CHANGE_CUMMUNITY_CURRENT_CATEGORY', categoryCode.value);
      // console.log('onDeleteFilterList ====>', category_store.value, categoryCode.value);
    }

    const onSelectChange = (e) => {
      limit.value = e.target.value;
      let cCode = categorylist.value;
      cCode.CODE = categoryCode.value
      updateHandler(1, categoryType.value, categoryCode.value)
    }   

    //카테고리 리스트
    const getCategorylist = async() => {    
      const res = await apiCall_g(`/board/categorylist?type=community`);
      var result =res.dataList;
      if(!result) result = [];
      return result
    }

    //공지사항 리스트
    const getNoticelist = async() => {    
      const res = await apiCall_g(`board/list?offset=0&categoryArr=notice&isTop=Y`);
      var result = res.dataList;     
      if(!result) result = [];
      return result
    }    

    const writeClickHandle = () => {
      if(!isLogin.value) {
        emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 이용 가능합니다."});
      } else {
        router.push({
          name: 'CommunityWrite',
        });
      }
    }

    const srchCommunity = () => {
      updateHandler(1, categoryType.value, categoryCode.value);
    }

    onUnmounted(()=> {     
      if(route.params.id) {
        return false;
      }
      if(page_store.value !== 'Community') {
        store.commit('common/CHANGE_CUMMUNITY_CURRENT_PAGE', 1);
      }
    })

    return {      
      isLogin,
      numberOfPages,
      boardList,
      currentPage, 
      updateHandler,
      onSelectChange,
      categorylist,
      categoryType,
      categoryCode,
      noticeList,
      writeClickHandle,
      srchType,
      srchKeyword,
      srchCommunity,
      page_store,
      onFilterSelect,
      onDeleteFilterList,
      onResetCategoryCode,
      category_store,
      allCategory,      
    }
  }
}
</script>

<style>

</style>